document.addEventListener('DOMContentLoaded', () => {
  const isiOS = /iP(hone|od|ad)/.test(navigator.platform) || 
                (/Mac/.test(navigator.platform) && 'ontouchend' in document);

  const loadDeferred = (root) => {
    const dm = root.closest?.('deferred-media') || root.querySelector?.('deferred-media') || null;
    if (!dm) return root;
    if (!dm.querySelector('video, iframe')) {
      if (typeof dm.loadContent === 'function') {
        dm.loadContent(false);
      } else {
        const t = dm.querySelector('template');
        if (t?.content?.firstElementChild) dm.appendChild(t.content.firstElementChild.cloneNode(true));
      }
    }
    return dm;
  };

  const wireVideo = (container) => {
    // remove any poster/overlay that can block taps
    const poster = container.querySelector('.deferred-media__poster, .product__media-poster, [data-media-poster]');
    if (poster) poster.style.display = 'none';

    const video = container.querySelector('video');
    if (!video) return;

    // iOS-required attributes (set both property and attribute)
    video.muted = true;               video.setAttribute('muted', '');
    video.playsInline = true;         video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = true;            video.setAttribute('autoplay', '');
    video.loop = true;                video.setAttribute('loop', '');
    video.preload = 'metadata';
    video.removeAttribute('controls');

    // try to play when ready and visible
    const tryPlay = () => {
      const p = video.play?.();
      if (p && typeof p.then === 'function') {
        p.catch(() => {
          // still blocked -> fallback button & user-gesture hooks
          addFallback(video);
        });
      }
    };

    // only start when in viewport (iOS won’t start media that’s offscreen)
    const startWhenVisible = () => {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            // calling load() after setting muted helps on iOS
            try { video.load(); } catch {}
            tryPlay();
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(video);
    };

    startWhenVisible();

    // keep controls off if theme re-adds them
    new MutationObserver(() => {
      if (video.hasAttribute('controls')) video.removeAttribute('controls');
    }).observe(video, { attributes: true, attributeFilter: ['controls'] });
  };

  const addFallback = (video) => {
    if (video.parentElement.querySelector('.dm-fallback-play')) return;

    const btn = document.createElement('button');
    btn.className = 'dm-fallback-play';
    btn.type = 'button';
    btn.textContent = 'Play';
    Object.assign(btn.style, {
      position: 'absolute', inset: '0', margin: 'auto', width: '120px', height: '48px',
      zIndex: '5', border: '0', borderRadius: '9999px', background: 'rgba(0,0,0,.6)',
      color: '#fff', cursor: 'pointer'
    });
    const container = video.parentElement;
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.appendChild(btn);

    const start = () => {
      video.muted = true;
      video.setAttribute('muted','');
      video.play().then(() => btn.remove()).catch(() => {
        // if still blocked, show native controls as last resort
        video.setAttribute('controls','');
        btn.remove();
      });
    };

    btn.addEventListener('click', (e) => { e.stopPropagation(); start(); });
    // Bonus: first touch anywhere on the page counts as a gesture for iOS
    const onceTouch = () => { start(); document.removeEventListener('touchstart', onceTouch, { passive: true }); };
    document.addEventListener('touchstart', onceTouch, { passive: true, once: true });
    // Also start on first scroll (often allowed on iOS)
    const onceScroll = () => { start(); window.removeEventListener('scroll', onceScroll, { passive: true }); };
    window.addEventListener('scroll', onceScroll, { passive: true, once: true });
  };

  // Process all media wrappers
  document.querySelectorAll('deferred-media, .product__media, .media, .product-media')
    .forEach((wrapper) => {
      const host = loadDeferred(wrapper);
      wireVideo(host || wrapper);
    });
});
